import "../App.css";
import React from "react";
import placeHolderDoc from "../imgs/placeholder-doc.svg";
import placeHolderVid from "../imgs/placeholder-vid.svg";
import firebase, { auth, provider } from "../firebase.js";
import placeHolder from "../imgs/placeholder.jpg";
import doc from "../imgs/document.png"
import logo from "../imgs/PAbyCirc.svg"
import logoblack from "../imgs/PAbyCircBlack.svg"
import ph from "../imgs/placeholder.jpg"
import Troubleshooting from "../components/troubleshooting"
import network from "../imgs/network.svg"


import Helmet from "react-helmet";
 
import image from "../imgs/image.jpg"

const db = firebase.firestore();

var storageRef = firebase.storage().ref();


var stopVideo = function ( element ) {
  var iframe = element.querySelector( 'iframe');
  var video = element.querySelector( 'video' );
  if ( iframe !== null ) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc;
  }
  if ( video !== null ) {
      video.pause();
  }
};

const DocIcon = () => {
  return (
    <svg
    className="docIcon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 14.8 18.7"
    >
      <g>
        <path class="st0" d="M8.4,6.4h6.2C12.2,4,10.8,2.6,8.4,0.2V6.4z" />
        <polygon
          class="st0"
          points="7.4,7.4 7.4,0 8.2,0 8.2,0 0,0 0,18.7 14.8,18.7 14.8,7.4 	"
        />
      </g>
    </svg>
  );
};

const PlayIcon = () => {
  return (
    <svg
    className="playIcon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 15.1 17.1"
    >
      <path
        class="st0"
        d="M14.5,7.6L1.7,0.1C0.9-0.3,0,0.3,0,1.1V16c0,0.8,0.9,1.4,1.7,1l12.9-7.4C15.3,9.1,15.3,8,14.5,7.6z"
      />
    </svg>
  );
};

const Detail = (props) => {
  return (
    <div className="details-wrapper">

{
        props.resource? props.resource.type == "video" ?   <div className="video-wrapper">
        <iframe
          src={
            "https://player.vimeo.com/video/" +
            props.resource.url.split("/")[
              props.resource.url.split("/").length - 1
            ]
          }
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen=""
        ></iframe>
      </div>: <div className="doc-wrapper">
          <img src={doc} />
        </div>:<div className="spinner">
            <span>
              <span>loading</span>
              <br />
              <span>•</span>
              <span>•</span>
              <span>•</span>
            </span>
          </div>
        
      }





      {props.resource ? (
        <div className="content">
          <h2>{props.title}</h2>
          <p>{props.resource.description}</p>

          { props.resource.type == "video" ?"":<button className="flat-button doc-cta">  
<svg version="1.1" xmlns="http://www.w3.org/2000/svg"   x="0px" y="0px"   viewBox="0 0 17 21"   >
 
 
<g>
	<path class="st0" d="M2.5,0.5c-1.1,0-2,0.9-2,2l0,16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-12l-6-6H2.5z"/>
	<polygon class="st1" points="9.5,7.5 9.5,2 15,7.5 	"/>
</g>
</svg>
 Read Document</button> }
        </div>
      ) : (
        ""
      )}


    </div>
  );
};

class GettingStarted extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    lightbox:false,
      gsStep3: [],
    };
  }

 handlePlayer=()=>{
   this.setState({trainer:false})
   this.getGsStep3(false)
 }

 handleTrainer=()=>{
  this.setState({trainer:true})
  this.getGsStep3(true)
}

getGsStep3 = (isTrainer) => {
  const resources = Object.entries(this.props.resources)
  .filter(([key, value]) => this.props.resources[key]['gs-step']==3)
  .filter(([key, value])=>isTrainer?this.props.resources[key]['user'].includes('trainer'):this.props.resources[key]['user'].includes('player'))
  .sort(([,a],[,b]) => a['gs-sort']-b['gs-sort'])
  .map(([key, value])=> {
    return key;
  })
  this.setState({ gsStep3: resources })
}

handleLBFalse=(e)=>{
  stopVideo(e);
  this.setState({
    lightbox:false,
    video:undefined
  })
}

handleLBTrue=(video)=>{
  this.setState({
    lightbox:true,
    video:video
  })
  
}

componentDidMount() {
  this.getGsStep3()
}

  render() {
    return (<>
      <Helmet>
        <meta name="description" content="Resources for Project Ares Trainers and Players. " />
 
 
        <meta property="og:locale" content="en_US" />
 
        <meta property="og:title" content="Getting Started | Project Ares Resource Center " />
        <meta property="og:description" content="Resources for Project Ares Trainers and Players. " />
 
        <meta property="og:site_name" content="Getting Started | Project Ares Resource Center " />
        <meta property="og:image" content={image} />
        <meta property="og:image:secure_url"  content={image} />
        <meta property="og:image:width" content="1280" />
        <meta property="og:image:height" content="720" />

        <link rel="canonical" href="https://projectares.academy/support" />
 
      </Helmet>
      <div className="getting-started-wrapper">


<div className={"pre-wrapper "+(this.state.trainer!==undefined?"clicked":"")}>
       
       <div className="getting-started-hero">
        
       <div className="center">
         <img src={logoblack}/><div>
         
      <p>Welcome to Project Ares.  We are looking forward to supporting you in your cyber security teaching, training, and learning journey.  </p>
       </div></div>
   
  
       </div>
  
  
  
       <div className="gs-buttons"> <button onClick={this.handlePlayer} className="trainer"><span>Getting Started: <h2>Player</h2></span>
       
       
       
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="443.4px"
     height="440.6px" viewBox="0 0 443.4 440.6"  >
   
  <g>
    <path class="st0" d="M186.8,223.5h114c5.7,0,10.8-3.5,12.9-8.8l31.2-80.5c1.5-3.9-1.4-8.1-5.6-8.1h-99.4c-5,0-9.6,2.9-11.7,7.5
      L186.8,223.5z"/>
    <path class="st0" d="M192,212.2h-63.9c0,0-4.9-0.6-4.9,5.3c0,5.9,4.9,5.7,4.9,5.7l58.7,0.3"/>
    
      <ellipse transform="matrix(0.2514 -0.9679 0.9679 0.2514 41.6494 400.6613)" class="st0" cx="279.8" cy="173.4" rx="12.1" ry="6.4"/>
    <path class="st0" d="M37.4,244.9h392.8c3.3,0,6.2-2,7.5-5l4.3-10.3c1.2-2.9-0.9-6.1-4-6.1H37.4"/>
    <path class="st0" d="M64.6,193.1c15.9-51.8,80.5-99.4,80.5-99.4"/>
    <path class="st0" d="M171.4,96.1c0,0,21.6,35.7,21.6,56.8s-38.8,54.7-38.8,54.7"/>
    <path class="st0" d="M193.1,209.8l-10.6-10.7c-1.2-1.2-3.1-1.5-4.6-0.6c-14.5,8.8-21,10.6-46.3,11.3c-26.7,0.7-67-16.7-67-16.7
      l-5.1,14.5c0,0-2.5,6.7,1.8,11.3c4.3,4.6,6.1,4.6,6.1,4.6"/>
    <path class="st0" d="M88.4,201.8c0,0,17.2-26.7,25.9-36.9c0.4-0.5,1.3,0.1,0.9,0.6c-5.9,9.3-19.5,31.2-22,37.7"/>
    <path class="st0" d="M176.9,76.2l-6.2,20.9c0,0-1.9,4.1-13.1,2c-11.2-2.1-12.4-5.3-12.4-5.3l11.2-22.5"/>
    <path class="st0" d="M171.4,23.8c0,0,21.7,15.7,21.7,38.2s-30.5,11.6-30.5,11.6s-9.8-2.3-20.7-16.9c-10.9-14.6,8.2-12.8,9.5-4.1
      c0,0,3.6,4.5,2.9-3.2c-0.7-7.7-3.2-19.3,8.2-24.4C162.5,24.9,167.3,22.6,171.4,23.8z"/>
    <path class="st0" d="M176.1,27.9c0,0,4.3-2.9,4.3-10.9S170.7,1,156.4,1c-14.3,0-26.2,13.1-28.3,17.4"/>
    <path class="st0" d="M123.2,35.2c0,0-3.6,37.6,19,37.6c0,0,5.8-0.1,8.2-6.8"/>
    <path class="st0" d="M117.2,16.7c0,0-35.7-2.4-44.2,45.2c0,0-10.5,35.4-16.6,40.9s-8.6,6.9-8.6,11.2s7.8,5.9,13.3,5.9
      s41.4-6.2,49-40.9s11.4-42.3,15.9-49C126,30,138.1,16.5,117.2,16.7z"/>
    <path class="st0" d="M228.4,244.9"/>
    <path class="st0" d="M82.5,318.4h94.4c4.7,0,8.6-3.8,8.6-8.6v-16.4c0-2.1-1.7-3.8-3.8-3.8H77.7c-2.1,0-3.8,1.7-3.8,3.8v16.4
      C73.9,314.6,77.7,318.4,82.5,318.4z"/>
    <line class="st0" x1="230.1" y1="244.9" x2="178.3" y2="289.6"/>
    <path class="st0" d="M219.4,254.2l10.7,3.4c0,0,1.9-0.2,7.6,9.7c5.7,10,29.2,53.7,49.2,127c0,0,0.2,2.4,4.3,4.5s25.4,14,25.4,14"/>
    <path class="st0" d="M183.7,285l28.9-3c0,0-3.3,11.2,0,24c3.3,12.8,60.4,86.8,62.8,89.2l-4.3,12.1"/>
    <path class="st0" d="M225.2,327.7c0,0-17.4,41.1-19.8,45.6c-2.4,4.5-5.5,8.1-4.3,13.8c1.2,5.7,5.5,20.2,5.5,20.2"/>
    <path class="st0" d="M206.3,282.7c0,0-10.9,10.5-13.3,27.2c-2.4,16.6-1,51.1-1,51.1s1.5,8.3-6.6,12.4"/>
    <path class="st0" d="M228.4,246.4c0,0,12,6.9,11.5,13.5c-0.5,6.7-0.8,9.9-0.8,9.9"/>
    <line class="st0" x1="85.1" y1="244.9" x2="6.6" y2="430.9"/>
    <line class="st0" x1="76.5" y1="244.9" x2="0.9" y2="426.3"/>
    <polyline class="st0" points="51.4,324.7 98.6,435.8 91.7,439.2 47.2,334.6 	"/>
    <line class="st0" x1="47.7" y1="314.1" x2="36.3" y2="288.2"/>
    <line class="st0" x1="43.3" y1="324.7" x2="30.9" y2="297"/>
    <line class="st0" x1="135.7" y1="318.4" x2="135.7" y2="412.8"/>
    <line class="st0" x1="126" y1="318.4" x2="126" y2="414"/>
    <polyline class="st0" points="402.7,244.9 320.9,439.2 313.8,435.4 393.4,244.9 	"/>
    <polyline class="st0" points="336.4,244.9 365.3,312.3 360.4,324 326.2,244.9 	"/>
    <polyline class="st0" points="369.4,324 416.3,434.4 408.7,439.2 364.8,335 	"/>
  </g>
  </svg>
  
       
       </button>
       <button onClick={this.handleTrainer} className="player"><span>Getting Started: <h2>Trainer</h2></span>
       
   
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="315.7px"
     height="479.8px" viewBox="0 0 315.7 479.8"   >
   
  <g>
    <path class="st0" d="M166.3,103.9c0,0-11.6,25.6-10.9,60s7,67.4,7,67.4"/>
    <path class="st0" d="M164.7,241.4l1.5,8.2c0,0,1.4,4.6,4.9,4.6s35.1,3.5,61.8-4.2l-1.6-10.7"/>
    <path class="st0" d="M231.2,222.2c0,0,7-57.6,14.4-72.3c0,0,11.6,16.5,10.5,30.5c-1.1,14-14.4,37.8-38.3,53.6"/>
    <path class="st0" d="M228.7,92l31.6,7.4c0,0,17.5,4.9,22.5,24.2s16.8,53.7,0,80.4s-61.4,38.6-61.4,38.6"/>
    <path class="st0" d="M194.7,89.5h-30.2c0,0-8.1,1.1-10.9,2.5s-25.6,8.4-36.5,4.9s-40.7,0.4-67.7-49.1c0,0-3.2-7.3-11.2-9.9
      S1.3,25.7,1.3,25.7s-1.8,4.9,3.2,6.3s11.9,3.9,11.9,3.9S12.2,52,24.8,56.9s13,5.2,19,4.9c0,0,11.6,75.5,79.3,77.6
      c0,0,27.6,0.7,34.1-2.4"/>
    <path class="st0" d="M91,90.3c0,0-10.6,14.6-11.8,33.9"/>
    <path class="st0" d="M39.9,46.7l-7-5.3l-10.5-1.8c0,0-1.4,4.2,3.2,7s10.9,10.9,10.9,10.9"/>
    <path class="st0" d="M216.6,233.1c0,0,10,7,0.9,13c-9.1,6-23.5,4.6-37.9-4.2"/>
    <line class="st0" x1="249.1" y1="201.8" x2="261.9" y2="224.4"/>
    <path class="st0" d="M171.2,254.1l32.3,219.7c0,0,0.4,5.6,10.9,4.9c10.5-0.7,11.6-3.2,11.6-3.2s-6.7-156.9-9.8-162.5"/>
    <path class="st0" d="M189.8,286.8l10.8,2.1c0,0,68.2,109.1,92.7,175.8"/>
    <path class="st0" d="M232.9,249.9c0,0,43.5,93.4,81.8,214.8"/>
    <path class="st0" d="M194.7,27.3c0,0-6.9,12.2-6.9,20.1s-4.7,25,11,24.6s22.5-8,22.9-10.9c0.5-2.9,4.5-6.6,4.5-6.6
      s7.5-6.5,3.9-10.6c-3.6-4.1-9,4.2-9.7,3.7s5.4-10.4-1.8-13.2c-7.2-2.8-33.1-4.5-33.1-21.6c0,0-0.4-11.8,8.2-11.8s11.8,8.9,19,8.9
      s25.6,5.4,25.6,18.5c0,0,8.3-1.7,8.3,6.4s-8.9,14.7-8.9,15.8c0,1.1,2.2,0.6,2.2,3.3s-8.6,7.2-17.5,7.2l5.8,35.4
      c0,0-2.1,4.2-16.8,5.3c-14.7,1.1-15.1-9.8-15.1-9.8V71.3"/>
    <path class="st0" d="M160.8,241.4H64.1c-5.1,0-9.6-3.1-11.4-7.8L25,162c-1.3-3.5,1.2-7.2,4.9-7.2h83.7c4.5,0,8.6,2.6,10.4,6.7
      L160.8,241.4z"/>
    <path class="st0" d="M156.2,231.3h56.8c0,0,4.4-0.5,4.4,4.7s-4.4,5.1-4.4,5.1l-52.1,0.2"/>
    
      <ellipse transform="matrix(0.9679 -0.2514 0.2514 0.9679 -46.6277 26.5323)" class="st0" cx="80.5" cy="195.8" rx="5.7" ry="10.8"/>
  </g>
  </svg>
  
       
       </button></div>
  
         </div>
    {this.state.trainer!==undefined?<div className="post-wrapper"> <div className="getting-started-hero">
       <div className="buttons">
         
    {this.state.trainer?  <button onClick={this.handlePlayer} className="clear-button">{"Change user Type"}</button>: <button onClick={this.handleTrainer} className="clear-button">{"Change user Type"}</button> 
         
       
         
      }   
         </div>
     <div className="center">
     <div className="lborder">
       <h1>Getting Started:</h1>
    <h2>{this.state.trainer?"Trainer":"Player"}</h2>
     </div>
     <img src={logo}/>  </div>
 

     </div>

     <div className="getting-started-blurb">
       <div>
<h2><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" ><path d="M0 0h24v24H0z" fill="none"/><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/></svg> Fast start to Project Ares. </h2><span>
<a href="https://circadence.com/contact/support">Contact us</a> if you still have questions</span></div>
     </div>
     <div className="getting-started-content">
       <div><span className="speech-bubble"><h5>Quick Tip:</h5><span>Bookmark the <a href="https://cyberbridge2.circadence.com/login">Project Ares Login page</a> for easy reference in your browser.</span></span>
    
{this.state.trainer?<svg className="trainer" version="1.1" xmlns="http://www.w3.org/2000/svg"   x="0px" y="0px" viewBox="0 0 377.3 636.3"   >
 
<g>
	<path class="st0" d="M149.4,260.4c0,0,11.6,25.6,10.9,60c-0.7,34.4-7,67.4-7,67.4"/>
	<path class="st0" d="M150.9,397.8l-1.5,8.2c0,0-1.4,4.6-4.9,4.6c-3.5,0-35.1,3.5-61.8-4.2l1.6-10.7"/>
	<path class="st0" d="M84.5,378.7c0,0-7-57.6-14.4-72.3c0,0-11.6,16.5-10.5,30.5c1.1,14,14.4,37.8,38.3,53.6"/>
	<path class="st0" d="M86.9,248.5l-31.6,7.4c0,0-17.5,4.9-22.5,24.2c-4.9,19.3-16.8,53.7,0,80.4S94.3,399,94.3,399"/>
	<path class="st0" d="M121,246h30.2c0,0,8.1,1.1,10.9,2.5c2.8,1.4,25.6,8.4,36.5,4.9s40.7,0.4,67.7-49.1c0,0,3.2-7.3,11.2-9.9
		c8.1-2.7,36.8-12.2,36.8-12.2s1.8,4.9-3.2,6.3c-4.9,1.4-11.9,3.9-11.9,3.9s4.2,16.1-8.4,21.1c-12.6,4.9-13,5.2-19,4.9
		c0,0-11.6,75.5-79.3,77.6c0,0-27.6,0.7-34.1-2.4"/>
	<path class="st0" d="M224.6,246.8c0,0,10.6,14.6,11.8,33.9"/>
	<path class="st0" d="M275.7,203.2l7-5.3l10.5-1.8c0,0,1.4,4.2-3.2,7s-10.9,10.9-10.9,10.9"/>
	<path class="st0" d="M99,389.5c0,0-10,7-0.9,13s23.5,4.6,37.9-4.2"/>
	<line class="st0" x1="66.6" y1="358.3" x2="53.7" y2="380.9"/>
	<path class="st0" d="M144.5,410.6l-32.3,219.7c0,0-0.4,5.6-10.9,4.9s-11.6-3.2-11.6-3.2s6.7-156.9,9.8-162.5"/>
	<path class="st0" d="M125.9,443.2l-10.8,2.1c0,0-68.2,109.1-92.7,175.8"/>
	<path class="st0" d="M82.7,406.4c0,0-43.5,93.4-81.8,214.8"/>
	<path class="st0" d="M121,183.8c0,0,6.9,12.2,6.9,20.1c0,8,4.7,25-11,24.6c-15.7-0.5-22.5-8-22.9-10.9c-0.5-2.9-4.5-6.6-4.5-6.6
		s-7.5-6.5-3.9-10.6c3.6-4.1,9,4.2,9.7,3.7c0.6-0.5-5.4-10.4,1.8-13.2s33.1-4.5,33.1-21.6c0,0,0.4-11.8-8.2-11.8s-11.8,8.9-19,8.9
		s-25.6,5.4-25.6,18.5c0,0-8.3-1.7-8.3,6.4s8.9,14.7,8.9,15.8s-2.2,0.6-2.2,3.3s8.6,7.2,17.5,7.2L87.3,253c0,0,2.1,4.2,16.8,5.3
		c14.7,1.1,15.1-9.8,15.1-9.8v-20.7"/>
	<path class="st0" d="M154.9,397.8h96.7c5.1,0,9.6-3.1,11.4-7.8l27.7-71.5c1.3-3.5-1.2-7.2-4.9-7.2H202c-4.5,0-8.6,2.6-10.4,6.7
		L154.9,397.8z"/>
	<path class="st0" d="M159.5,387.8h-56.8c0,0-4.4-0.5-4.4,4.7s4.4,5.1,4.4,5.1l52.1,0.2"/>
	
		<ellipse transform="matrix(0.2514 -0.9679 0.9679 0.2514 -164.9403 491.281)" class="st0" cx="235.1" cy="352.3" rx="10.8" ry="5.7"/>
</g>
<path class="st1" d="M348.5,1H177.2c-15.3,0-27.8,12.4-27.8,27.8v80.2c0,15.3,12.4,27.8,27.8,27.8h19.6c1.2,18.5-0.6,59.4-40.4,59.4
	c0,0,75.2,2.7,81.8-59.4h110.4c15.3,0,27.8-12.4,27.8-27.8V28.8C376.3,13.4,363.9,1,348.5,1z"/>
</svg> :
<svg  className="player"  version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"   viewBox="0 0 453.1 572.3"  >
 
<g>
	<path class="st0" d="M424.3,1H253c-15.3,0-27.8,12.4-27.8,27.8v80.2c0,15.3,12.4,27.8,27.8,27.8h19.6c1.2,18.5-0.6,59.4-40.4,59.4
		c0,0,75.2,2.7,81.8-59.4h110.4c15.3,0,27.8-12.4,27.8-27.8V28.8C452.1,13.4,439.6,1,424.3,1z"/>
	<g>
		<path class="st1" d="M186.8,355.2h114c5.7,0,10.8-3.5,12.9-8.8l31.2-80.5c1.5-3.9-1.4-8.1-5.6-8.1h-99.4c-5,0-9.6,2.9-11.7,7.5
			L186.8,355.2z"/>
		<path class="st1" d="M192,343.9h-63.9c0,0-4.9-0.6-4.9,5.3s4.9,5.7,4.9,5.7l58.7,0.3"/>
		
			<ellipse transform="matrix(0.2514 -0.9679 0.9679 0.2514 -85.8225 499.2568)" class="st1" cx="279.8" cy="305.1" rx="12.1" ry="6.4"/>
		<path class="st1" d="M37.4,376.6h392.8c3.3,0,6.2-2,7.5-5l4.3-10.3c1.2-2.9-0.9-6.1-4-6.1H37.4"/>
		<path class="st1" d="M64.6,324.8c15.9-51.8,80.5-99.4,80.5-99.4"/>
		<path class="st1" d="M171.4,227.8c0,0,21.6,35.7,21.6,56.8s-38.8,54.7-38.8,54.7"/>
		<path class="st1" d="M193.1,341.5l-10.6-10.7c-1.2-1.2-3.1-1.5-4.6-0.6c-14.5,8.8-21,10.6-46.3,11.3c-26.7,0.7-67-16.7-67-16.7
			l-5.1,14.5c0,0-2.5,6.7,1.8,11.3c4.3,4.6,6.1,4.6,6.1,4.6"/>
		<path class="st1" d="M88.4,333.5c0,0,17.2-26.7,25.9-36.9c0.4-0.5,1.3,0.1,0.9,0.6c-5.9,9.3-19.5,31.2-22,37.7"/>
		<path class="st1" d="M176.9,207.9l-6.2,20.9c0,0-1.9,4.1-13.1,2s-12.4-5.3-12.4-5.3l11.2-22.5"/>
		<path class="st1" d="M171.4,155.5c0,0,21.7,15.7,21.7,38.2s-30.5,11.6-30.5,11.6s-9.8-2.3-20.7-16.9c-10.9-14.6,8.2-12.8,9.5-4.1
			c0,0,3.6,4.5,2.9-3.2c-0.7-7.7-3.2-19.3,8.2-24.4C162.5,156.6,167.3,154.3,171.4,155.5z"/>
		<path class="st1" d="M176.1,159.6c0,0,4.3-2.9,4.3-10.9c0-8.1-9.7-15.9-24-15.9c-14.3,0-26.2,13.1-28.3,17.4"/>
		<path class="st1" d="M123.2,166.9c0,0-3.6,37.6,19,37.6c0,0,5.8-0.1,8.2-6.8"/>
		<path class="st1" d="M117.2,148.4c0,0-35.7-2.4-44.2,45.2c0,0-10.5,35.4-16.6,40.9c-6.2,5.5-8.6,6.9-8.6,11.2
			c0,4.3,7.8,5.9,13.3,5.9s41.4-6.2,49-40.9s11.4-42.3,15.9-49C126,161.7,138.1,148.2,117.2,148.4z"/>
		<path class="st1" d="M228.4,376.6"/>
		<path class="st1" d="M82.5,450.1h94.4c4.7,0,8.6-3.8,8.6-8.6v-16.4c0-2.1-1.7-3.8-3.8-3.8H77.7c-2.1,0-3.8,1.7-3.8,3.8v16.4
			C73.9,446.3,77.7,450.1,82.5,450.1z"/>
		<line class="st1" x1="230.1" y1="376.6" x2="178.3" y2="421.3"/>
		<path class="st1" d="M219.4,385.9l10.7,3.4c0,0,1.9-0.2,7.6,9.7c5.7,10,29.2,53.7,49.2,127c0,0,0.2,2.4,4.3,4.5s25.4,14,25.4,14"
			/>
		<path class="st1" d="M183.7,416.7l28.9-3c0,0-3.3,11.2,0,24s60.4,86.8,62.8,89.2L271,539"/>
		<path class="st1" d="M225.2,459.4c0,0-17.4,41.1-19.8,45.6c-2.4,4.5-5.5,8.1-4.3,13.8c1.2,5.7,5.5,20.2,5.5,20.2"/>
		<path class="st1" d="M206.3,414.4c0,0-10.9,10.5-13.3,27.2c-2.4,16.6-1,51.1-1,51.1s1.5,8.3-6.6,12.4"/>
		<path class="st1" d="M228.4,378.1c0,0,12,6.9,11.5,13.5c-0.5,6.7-0.8,9.9-0.8,9.9"/>
		<line class="st1" x1="85.1" y1="376.6" x2="6.6" y2="562.6"/>
		<line class="st1" x1="76.5" y1="376.6" x2="0.9" y2="558"/>
		<polyline class="st1" points="51.4,456.4 98.6,567.5 91.7,570.9 47.2,466.3 		"/>
		<line class="st1" x1="47.7" y1="445.8" x2="36.3" y2="419.9"/>
		<line class="st1" x1="43.3" y1="456.4" x2="30.9" y2="428.7"/>
		<line class="st1" x1="135.7" y1="450.1" x2="135.7" y2="544.5"/>
		<line class="st1" x1="126" y1="450.1" x2="126" y2="545.7"/>
		<polyline class="st1" points="402.7,376.6 320.9,570.9 313.8,567.1 393.4,376.6 		"/>
		<polyline class="st1" points="336.4,376.6 365.3,444 360.4,455.7 326.2,376.6 		"/>
		<polyline class="st1" points="369.4,455.7 416.3,566.1 408.7,570.9 364.8,466.7 		"/>
	</g>
</g>
</svg>
}

       
       </div>
       <div className="center">
         <div className="step open">
           <div className="title" onClick={(event)=>{event.target.parentNode.classList.toggle('open')}}><span className="number"> 1</span> Getting Started</div>
           <div className="step-content">
            
         
                      
                      <Troubleshooting button=  { <div style={{pointerEvents:"none"}}> <div className="content-item">
                        
                        <img src={network}/><span>Test Your Connection  </span>
                                
                      </div></div>}/>
             
             {Object.keys(this.props.resources)
            .filter(key => this.props.resources[key]['gs-step']==1)
            .filter(key=>this.state.trainer?this.props.resources[key]['user'].includes('trainer'):this.props.resources[key]['user'].includes('player'))
             .map((key, index) => {
            return (
          <>
            
  
             
{ this.props.resources[key].type=="video"?<div onClick={()=>this.handleLBTrue(this.props.resources[key].url)} style={{textDecoration:"none",color:"inherit"}}> <div className="content-item">
            
            <img src={placeHolderVid}/><span><PlayIcon/>Video </span>
                              <span>{key}</span>
                  </div></div>  : <a target="_blank" href={this.props.resources[key].url} style={{textDecoration:"none",color:"inherit"}}> <div className="content-item">
                        
                                <img src={placeHolderDoc}/><span><DocIcon/>Document </span>
                                          <span>{key}</span>
                              </div></a> }
                   
           
</>



            );
          })}



 

           </div>
         </div>

         <div className="step">
           <div className="title" onClick={(event)=>{event.target.parentNode.classList.toggle('open')}}><span className="number"> 2</span> Platform Navigation</div>
           <div className="step-content">



           
           {Object.keys(this.props.resources)
            .filter(key => this.props.resources[key]['gs-step']==2)
            .filter(key=>this.state.trainer?this.props.resources[key]['user'].includes('trainer'):this.props.resources[key]['user'].includes('player'))
             .map((key, index) => {
            return (
              <>
            
  
             
              { this.props.resources[key].type=="video"?<div onClick={()=>this.handleLBTrue(this.props.resources[key].url)} style={{textDecoration:"none",color:"inherit"}}> <div className="content-item">
                          
                          <img src={placeHolderVid}/><span><PlayIcon/>Video </span>
                                            <span>{key}</span>
                                </div></div>  : <a target="_blank" href={this.props.resources[key].url} style={{textDecoration:"none",color:"inherit"}}> <div className="content-item">
                                      
                                              <img src={placeHolderDoc}/><span><DocIcon/>Document </span>
                                                        <span>{key}</span>
                                            </div></a> }
                                 
                         
              </>
              

            );
          })}



           </div>
         </div>



         <div className="step">
           <div className="title" onClick={(event)=>{event.target.parentNode.classList.toggle('open')}}><span className="number"> 3</span> Beyond the Basics</div>
           <div className="step-content">

           
           {
            this.state.gsStep3.map((key, index) => {
            return (
              <>
              { this.props.resources[key].type=="video"?<div onClick={()=>this.handleLBTrue(this.props.resources[key].url)} style={{textDecoration:"none",color:"inherit"}}> <div className="content-item">
                          
                          <img src={placeHolderVid}/><span><PlayIcon/>Video </span>
                                            <span>{key}</span>
                                </div></div>  : <a target="_blank" href={this.props.resources[key].url} style={{textDecoration:"none",color:"inherit"}}> <div className="content-item">
                                              <img src={placeHolderDoc}/><span><DocIcon/>Document </span>
                                                        <span>{key}</span>
                                            </div></a> }
                                 
                         
              </>
              


            );
          })}



           </div>
         </div>








       </div>
       <div></div>
     </div></div>:""}



     <div className={this.state.lightbox?"lightbox-wrapper active":"lightbox-wrapper"}  onClick={(event)=>this.handleLBFalse(event.target)}>

       <div className="lightbox">
         
        {this.state.video? <iframe src={"https://player.vimeo.com/video/"+(this.state.video.split("/")[3])} width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>:""}

 
       </div>
     </div>
      </div>
   </> );
  }
}

export default GettingStarted;
 